import api from './axios'

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = window.atob(base64)
  const out = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i)
  return out
}

export function isPushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
}

export async function ensurePermission() {
  if (Notification.permission === 'granted') return 'granted'
  if (Notification.permission === 'denied') return 'denied'
  return await Notification.requestPermission()
}

async function registerSW() {
  return await navigator.serviceWorker.register('/sw.js')
}

function subscriptionToBackendPayload(sub) {
  const json = sub.toJSON()
  return {
    endpoint: json.endpoint,
    keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
  }
}

export async function enablePush() {
  if (!isPushSupported()) throw new Error('Push not supported in this browser')
  const perm = await ensurePermission()
  if (perm !== 'granted') throw new Error('Notification permission denied')

  const reg = await registerSW()
  const keyRes = await api.get('/api/v1/push/vapid-public-key')
  const publicKey = keyRes.data?.public_key
  if (!publicKey) throw new Error('Server VAPID key missing')

  let sub = await reg.pushManager.getSubscription()
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    })
  }

  await api.post('/api/v1/push/subscribe', subscriptionToBackendPayload(sub))
  return sub
}

export async function disablePush() {
  if (!('serviceWorker' in navigator)) return
  const reg = await navigator.serviceWorker.getRegistration('/sw.js')
  if (!reg) return
  const sub = await reg.pushManager.getSubscription()
  if (!sub) return
  try {
    await api.delete('/api/v1/push/subscribe', { data: { endpoint: sub.endpoint } })
  } catch (e) { /* ignore */ }
  await sub.unsubscribe()
}

export async function getPushState() {
  if (!isPushSupported()) return { supported: false, enabled: false, permission: 'default' }
  const permission = Notification.permission
  const reg = await navigator.serviceWorker.getRegistration('/sw.js')
  const sub = reg ? await reg.pushManager.getSubscription() : null
  return { supported: true, enabled: !!sub && permission === 'granted', permission }
}
